import '@styles/common.less';
import '@styles/layout.less';
import './home.less';
import '@common';

import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

import LazyLoad from 'vanilla-lazyload';
import { Autoplay } from 'swiper/modules';
import anime from 'animejs';

Swiper.use([Autoplay]);

document.addEventListener('DOMContentLoaded', () => {
  new LazyLoad({
    elements_selector: '.lazy',
    threshold: 300,
  });


  const swiperEl = document.querySelector('.swiper');
  if (swiperEl) {
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 'auto',
      // speed: 600,
      autoplay: true,
    });
  }
});
